export default __webpack_public_path__ + "static/media/icon-plus.edd67f7e.svg";